// frontend/src/components/Financeiro/FinanceiroContabilidade.js
// =============================================
// CONTABILIDADE — Sub-abas dentro do módulo Financeiro
// ✅ Painel (DashboardContabilidade existente)
// ✅ Apuramento IVA detalhado
// ✅ Livro Razão
// ✅ Submissões às Finanças
// =============================================
import React, { useState } from 'react';
import { Icon } from './SharedComponents';
import DashboardContabilidade from './DashboardContabilidade';
import ContabilidadeIVA from './ContabilidadeIVA';
import ContabilidadeLivroRazao from './ContabilidadeLivroRazao';
import ContabilidadeSubmissoes from './ContabilidadeSubmissoes';

const SUB_ABAS = [
    { id: 'painel', label: 'Painel', icone: 'dashboard' },
    { id: 'iva', label: 'Apuramento IVA', icone: 'receipt_long' },
    { id: 'razao', label: 'Livro Razão', icone: 'list_alt' },
    { id: 'submissoes', label: 'Submissões', icone: 'cloud_upload' }
];

export default function FinanceiroContabilidade() {
    const [subAba, setSubAba] = useState('painel');

    return (
        <div className="fin-contab-wrapper">
            {/* ===== SUB-ABAS ===== */}
            <nav className="fin-sub-abas">
                {SUB_ABAS.map(sa => (
                    <button
                        key={sa.id}
                        className={`fin-sub-aba-btn ${subAba === sa.id ? 'ativa' : ''}`}
                        onClick={() => setSubAba(sa.id)}
                    >
                        <Icon
                            name={sa.icone}
                            size={14}
                            color={subAba === sa.id ? '#fff' : 'currentColor'}
                        />
                        <span>{sa.label}</span>
                    </button>
                ))}
            </nav>

            {/* ===== CONTEÚDO ===== */}
            <div className="fin-sub-conteudo">
                {subAba === 'painel' && <DashboardContabilidade />}
                {subAba === 'iva' && <ContabilidadeIVA />}
                {subAba === 'razao' && <ContabilidadeLivroRazao />}
                {subAba === 'submissoes' && <ContabilidadeSubmissoes />}
            </div>
        </div>
    );
}